app.service('datelocal',function(html){

    function setEvents(){
        $('body').on('input change input', '.js-datelocal-date, .js-datelocal-time', function(){
            updateLocaltime(this);
        });
        $('body').on('change input', '.js-datelocal-input', function(){
            updateDateAndTimeInputs(this);
        });
    }

    function updateLocaltime(elem) {
        let $parent = $(elem).closest('.js-datelocal-wrapper');
        let dateInputVal = $parent.find('.js-datelocal-date').val();
        let timeInputVal = $parent.find('.js-datelocal-time').val();
        let $input = $parent.find('.js-datelocal-input');
        let nextValue = '';

        if(dateInputVal && timeInputVal) {
            $input.val(`${dateInputVal}T${timeInputVal}`);
        } else if(dateInputVal) {
            nextValue = `${dateInputVal}`;
        }

        if($input.val() !== nextValue) {
            $input.val(nextValue);
        } else {
            $input.val('');
        }
    }

    function updateDateAndTimeInputs(elem) {
        let $parent = $(elem).closest('.js-datelocal-wrapper');
        let value = $parent.find('.js-datelocal-input').val();
        let dateValue = '';
        let timeValue = '00:00';

        if (value) {
            let values = value.split('T');
            dateValue = values[0];
            if (values[1]) {
                timeValue = values[1];
            }
        }

        $parent.find('.js-datelocal-date').val(dateValue);
        $parent.find('.js-datelocal-time').val(timeValue);
    }

    function init(){
        setEvents();
    }
    return {
        init
    }
});
